import flatpickr from 'flatpickr';

export default class DatePicker {

	static init() {
		document.querySelectorAll('input[type="date"]').forEach((input) => {
			const date = input.getAttribute('value');
			const minDate = input.getAttribute('data-min-date');
			const maxDate = input.getAttribute('data-max-date');
			const inline = input.getAttribute('data-inline') == '1';
	
			let options = {
				dateFormat: 'Y-m-d',
				disableMobile: true,
				inline: inline, 
			};
	
			if(minDate) options.minDate = minDate;
			if(minDate) options.maxDate = maxDate;
	
			const datePicker = flatpickr(input, options);
			if (date)
				datePicker.setDate(date);
		});
	}
}